import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partnering-offshore-dev',
  templateUrl: './partnering-offshore-dev.component.html',
  styleUrls: ['./partnering-offshore-dev.component.css']
})
export class PartneringOffshoreDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/partnering-offshore-dev/partnering-offshore-dev.component.ts